import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mjvutrueq2: FaireBrandEntity = {
  token: "b_mjvutrueq2",
  type: "brand",
  name: "K-Beauty Distribution Group",
  avatarUrl:
    "https://cdn.faire.com/fastly/50083e7d420a18ed7f5ef8c3d6cc12b113660ec6206b0305e5e2dbec598ec1ac.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/29075d61c08e02a292f9f4981f31e39c4fa8aca20a02fcdd8e724e9edf4f8e8a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/50083e7d420a18ed7f5ef8c3d6cc12b113660ec6206b0305e5e2dbec598ec1ac.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/29075d61c08e02a292f9f4981f31e39c4fa8aca20a02fcdd8e724e9edf4f8e8a.png",
  location: "Queens, NY, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Kbeauty Distribution Group is a global wholesale distributor specializing in Korean beauty brands. We work directly with brands and authorized distributors in Korea to provide authentic K-beauty products to retailers worldwide.\n\nOur mission is to make Korean skincare sourcing easier for retailers by offering reliable inventory, competitive pricing, and efficient fulfillment. Orders ship from our U.S. warehouse, and we support global shipping so retailers around the world can access trending K-beauty products without complicated import logistics.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:11.916Z",
    importedBy: "entity-db-cli",
  },
};
